export default __webpack_public_path__ + "static/media/bitcoinyayLogo.79c29018.webp";